exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".translate-x-full {\n  transform: translateX(100%);\n}\r\n", ""]);

// exports
